import { render, staticRenderFns } from "./newsListInfo.vue?vue&type=template&id=7c2d8e8c&scoped=true"
import script from "./newsListInfo.vue?vue&type=script&lang=js"
export * from "./newsListInfo.vue?vue&type=script&lang=js"
import style0 from "./newsListInfo.vue?vue&type=style&index=0&id=7c2d8e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d8e8c",
  null
  
)

export default component.exports